<template>
  <div :class="['financed-plan-form', { 'with-error': paymentMethodError }]">
    <h2 class="title">Zahlungsart</h2>
    <p class="financed-plan-form__sub-title">
      Wie möchten Sie Ihr neues Fahrzeug
      <strong>{{ order.headline }}</strong> bezahlen?
    </p>
    <div class="financed-plan-form__notes margin">
      <div>
        <p class="supersmall">
        <strong><i class="fas fa-bell" /> Übrigens:</strong> Sie haben sich ein Fahrzeug mit einem
        der <b>besten Preise in Deutschland</b> ausgesucht.
        </p>
      </div>
    </div>
    <form>
      <!-- <div
        :class="['radio-form-item', { active: isFinancingPaymentMethod }]"
        @click="() => handleCheckboxChange('financing')"
      >
        <input
          :checked="isFinancingPaymentMethod"
          value="financing"
          type="radio"
        />
        <div class="radio-form-item__top-content">
          <div>
            <h4>Online-Finanzierung</h4>
          </div>
          <p v-if="!isFinancingPaymentMethod">
            Wir führen für Sie bei einer unserer Partner-Banken eine
            Finanzierungsanfrage durch.
          </p>
        </div>
        <div v-if="isFinancingPaymentMethod" class="financed-plan">
          <div>
            <div class="financed-plan__deposit">
              <div
                :class="[{ active: withBallon }]"
                @click="() => changeBallonState(true)"
              >
                <h3>Gleichbleibend mit Schlussrate</h3>
                <p>
                  Besonders günstige monatliche Rate. Am Laufzeitende
                  Schlussrate bezahlen oder weiterfinanzieren.
                </p>
              </div>
              <div
                :class="[{ active: !withBallon }]"
                @click="() => changeBallonState(false)"
              >
                <h3>Gleichbleibend ohne Schlussrate</h3>
                <p>
                  Keine Schlussrate. Am Ende der Laufzeit haben Sie das Fahrzeug
                  abbezahlt.
                </p>
              </div>
            </div>
            <div class="financed-plan__inputs">
              <div>
                <label class="financed-plan__label">
                  <h5>Anzahlung</h5>
                  <CurrencyInput
                    v-model="deposit"
                    locale="de-DE"
                    :currency="null"
                    distraction-free
                    :allow-negative="false"
                    :auto-decimal-mode="false"
                    :precision="0"
                  />
                </label>
                <label v-if="withBallon" class="financed-plan__label">
                  <h5>Schlussrate</h5>
                  <CurrencyInput
                    v-model="currentFinancingPlan.ballonAmount"
                    locale="de-DE"
                    :currency="null"
                    distraction-free
                    :allow-negative="false"
                    :auto-decimal-mode="false"
                    :precision="0"
                    disabled
                  />
                </label>
                <label class="financed-plan__range">
                  <div>
                    <h5>Laufzeit</h5>
                    <p>{{ rangeOptions.value }} Monate</p>
                  </div>
                  <RangeSlider
                    :min="rangeOptions.minValue"
                    :max="rangeOptions.maxValue"
                    step="1"
                    v-model="rangeOptions.value"
                  />
                </label>

              </div>
            </div>
          </div>
          <div>
            <div class="financed-plan__calculator">
              <div
                style="border-bottom:1px solid rgba(0,0,0,0.15);padding-bottom:8px;"
              >
                <span><strong>Finanzierung im Überblick</strong></span>
              </div>
              <div>
                <span>Fahrzeugpreis</span>
                <span>{{ formattedPrice(price || 0) }}</span>
              </div>
              <div>
                <span>Einmalige Anzahlung</span>
                <span> {{ formattedPrice(deposit || 0) }}</span>
              </div>
              <div
                :style="
                  !withBallon &&
                    'border-bottom:1px solid rgba(0,0,0,0.15);padding-bottom:8px;'
                "
              >
                <span>Laufzeit</span>
                <span>{{ rangeOptions.value }} Monate</span>
              </div>
              <div
                v-if="withBallon"
                style="border-bottom:1px solid rgba(0,0,0,0.15);padding-bottom:8px;"
              >
                <span>Schlussrate (letzte Rate)</span>
                <span>{{
                  formattedPrice(currentFinancingPlan.ballonAmount || 0)
                }}</span>
              </div>
              <div>
                <span>Monatsrate</span>
                <span>{{
                  formattedPrice(currentFinancingPlan.installment || 0)
                }}</span>
              </div>
              <div style="opacity:0.6"> 
                <span>Effektiver Jahreszins</span>
                <span>{{ currentFinancingPlan.effectiveInterest }} %</span>
              </div>
            </div>

            <div>

                <div class="financed-plan__price-container">
                  <p class="financed-plan__price">
                    {{ formattedPrice(currentFinancingPlan.installment || 0) }}
                  </p>
                  <p>Monatliche Rate</p>
                </div>

                <div style="display:flex;justify-content:end;">
                  <img
                    src="../assets/images/financing-banks.png"
                    alt="Bank11"
                  />
                </div>

          </div>

            <label class="financed-plan-form__checkbox mobile-only">
              <div>
                <div class="custom-checkbox">
                  <input
                    :checked="financingPlus"
                    id="financing-plus-checkbox"
                    type="checkbox"
                    @input="changeFinancingPlus"
                  />
                  <label for="financing-plus-checkbox" />
                </div>
                <p>
                  Ich bin noch an anderen Finanzie-<br />rungsarten (z.B.
                  auxmoney) interessiert.
                </p>
              </div>
            </label>
          </div>
        </div>
        <div v-if="isFinancingPaymentMethod" class="financed-plan-form__notes">
          <div>
            <p>
              <i class="fas fa-bell" /> Nach Abschluss der Bestellung werden Sie automatisch auf die Online-Antragsstrecke 
              unserer Partnerbank weitergeleitet. Bitte schließen Sie dort die Finanzierung 
              einfach und bequem online ab, damit wir Ihr Wunschfahrzeug für Sie reservieren können.
            </p>
          </div>
          <label class="financed-plan-form__checkbox">
            <div>
              <div class="custom-checkbox">
                <input
                  :checked="financingPlus"
                  id="financing-plus-checkbox"
                  type="checkbox"
                  @input="changeFinancingPlus"
                />
                <label for="financing-plus-checkbox" />
              </div>
              <p>
                Ich bin noch an anderen Finanzierungsarten (z.B.
                auxmoney) interessiert.
              </p>
            </div>
          </label>
        </div>        
      </div> -->
      <div
        :class="['radio-form-item', { active: paymentMethod === 'self_pay' }]"
        @click="() => handleCheckboxChange('self_pay')"
      >
        <input
          :checked="true"
          value="self_pay"
          type="radio"
        />
        <div class="radio-form-item__top-content">
          <div>
            <h4>Barkauf</h4>
          </div>
          <p>
            Zahlung des kompletten Fahrzeugpreises erfolgt nach
            Vertragsabschluss via Überweisung.
          </p>
          <div v-if="isSelfPayTooltipOpen" class="financed-plan-form__notes">
            <button @click.stop="closeTooltip('self_pay')">
              <i class="fas fa-times" />
            </button>
            <div>
              <p><i class="fas fa-bell" /> <b>Unser Tipp:</b>
                Um sicherzustellen, dass Ihnen kein/e andere/r Käufer*in
                zuvorkommt, überweisen Sie direkt nach Rechnungsstellung via
                Online-Direktzahlung (Direct Payment). Echtzeit Überweisung an 365 Tagen im Jahr und somit schnelle Auftragsbearbeitung durch frühen Zahlungseingang.
              </p>
            </div>
          </div>
        </div>
      </div>
      <p v-if="paymentMethodError" class="error">Bitte Option wählen.</p>
      <div
        class="radio-form-item disabled"
      >
      <input
          :checked="false"
          disabled
          type="radio"
        />
      <div class="radio-form-item__top-content">
        <div>
          <h4>
            Weitere Zahlungsmethoden
          </h4>
          
        </div>
        <p>
            Leider sind derzeit keine weiteren Zahlungsmethoden verfügbar.
          </p>
      </div>
    </div>
      <button class="btn" @click="updateOrderData">{{ editMode ? 'Änderungen übernehmen' : 'Nächster Schritt'}}</button>
    </form>
  </div>
</template>

<script>
import RangeSlider from "vue-range-slider";
import "vue-range-slider/dist/vue-range-slider.css";
import { getFinancingPlans } from "@/api/financing";
import { formatPrice } from "@/utils/price-helpers";
import { CurrencyInput } from "vue-currency-input";

export default {
  components: {
    RangeSlider,
    CurrencyInput,
  },
  props: ["order", "editMode"],
  data() {
    const isBallonExistInParams =
      this.$route.query.deposit && this.$route.query.term;
    const isPaymentMethodExistInParams =
      this.$route.query.paymentMethod && this.$route.query.paymentMethod != "";
    return {
      isSelfPayTooltipOpen: false,
      financingPlus: this.order.payment_method === "financing_plus",
      deposit:
        this.$route.query.deposit ||
        this.order.first_payment_raw ||
        this.order.car_info.initial_financing_offer.down_payment ||
        0,
      depositTimer: null,
      rangeTimer: null,
      paymentMethod: isPaymentMethodExistInParams
        ? this.$route.query.paymentMethod
        : this.order.payment_method !== undefined
        ? this.order.payment_method
        : "",
      paymentMethodError: false,
      withBallon: isBallonExistInParams
        ? !!this.$route.query.ballonAmount
        : !!this.order.last_payment_raw,
      responseData: { ballonAmount: {}, withoutBallonAmount: {} },
      rangeOptions: {
        value:
          +this.$route.query.term ||
          this.order.term_raw ||
          this.order.car_info.initial_financing_offer.term,
        minValue: 12,
        maxValue: 96,
      },
      currentFinancingPlan: {
        ballonAmount:
          (this.$route.query.ballonAmount && this.order.last_payment_raw) || 0,
        deposit:
          this.$route.query.deposit ||
          this.order.first_payment_raw ||
          this.order.car_info.initial_financing_offer.down_payment ||
          0,
        effectiveInterest: 4.49,
        installment: this.order.monthly_rate_raw || 0,
        term:
          +this.$route.query.term ||
          this.order.term_raw ||
          this.order.car_info.initial_financing_offer.term,
        total: 0,
      },
    };
  },
  computed: {
    rangeValue() {
      return this.rangeOptions.value;
    },
    price() {
      const { customer: price } = this.order.car_info.price;
      return price;
    },
    isFinancingPaymentMethod() {
      return (
        this.paymentMethod === "financing" ||
        this.paymentMethod === "financing_plus"
      );
    },
  },
  watch: {
    deposit(value) {
      if (value) {
        if (this.depositTimer) {
          clearTimeout(this.depositTimer);
          this.depositTimer = null;
        }
        this.depositTimer = setTimeout(() => {
          this.getPlans();
        }, 500);
      }
    },
    rangeValue() {
      if (this.rangeTimer) {
        clearTimeout(this.rangeTimer);
        this.rangeTimer = null;
      }
      this.rangeTimer = setTimeout(() => {
        this.setCurrentPriceConfig();
      }, 500);
    },
    paymentMethod(val) {
      if (val && this.paymentMethodError) {
        this.paymentMethodError = false;
      }
      // console.log(444, val)
      // if (val && val === 'financing_plus') this.financingPlus = true;
    },
  },
  mounted() {
    this.getPlans();
  },
  methods: {
    handleCheckboxChange(value) {
      if (value === "self_pay") {
        this.isSelfPayTooltipOpen = true;
        this.financingPlus = false;
        this.paymentMethod = value;
      } else {
        this.isSelfPayTooltipOpen = false;
      }
      this.paymentMethod = value;
    },
    updateOrderData(e) {
      e.preventDefault();
      const isValid = this.validateForm();
      if (isValid) {
        const params = {
          payment_method: this.paymentMethod,
        };
        if (this.isFinancingPaymentMethod) {
          params.finance_plan = {
            total: this.currentFinancingPlan.total,
            deposit: this.deposit,
            term: this.currentFinancingPlan.term,
            installment: this.currentFinancingPlan.installment,
            ballon_amount: this.currentFinancingPlan.ballonAmount,
            financing_amount: this.price - this.deposit,
            interest_rate: this.currentFinancingPlan.effectiveInterest
          };
        }
        this.$emit("updateOrderStep", this.order.token, params);
      }
    },
    validateForm() {
      let noError = true;
      if (this.paymentMethod === "") {
        this.paymentMethodError = true;
        noError = false;
      } else {
        this.paymentMethodError = false;
      }
      if (noError) {
        this.paymentMethodError = false;
      }
      return noError;
    },
    getPlans() {
      getFinancingPlans(this.price, this.deposit).then((res) => {
        this.responseData = this.filterResponseData(res);
        this.setRangeOptions();
        this.setCurrentPriceConfig();
      });
    },
    changeBallonState(value) {
      this.withBallon = value;
      if (value === false) {
        this.currentFinancingPlan.ballonAmount = 0;
      }
      this.setRangeOptions();
      this.setCurrentPriceConfig();
    },
    setRangeOptions() {
      const currentData = this.withBallon
        ? this.responseData.ballonAmount
        : this.responseData.withoutBallonAmount;
      const minValue = currentData.length && currentData[0].term;
      const maxValue = currentData.length
        ? currentData[currentData.length - 1].term
        : 96;
      let value =
        minValue > this.rangeOptions.value
          ? Math.floor((minValue + maxValue) / 2)
          : this.rangeOptions.value;
      if (value > maxValue || value < minValue) {
        value = 48;
      }
      this.rangeOptions = { ...this.rangeOptions, minValue, maxValue, value };
    },
    setCurrentPriceConfig() {
      const currentData = this.withBallon
        ? this.responseData.ballonAmount
        : this.responseData.withoutBallonAmount;
      const result = currentData.find(
        (item) => item.term === this.rangeOptions.value
      );
      this.currentFinancingPlan = { ...result } || this.currentFinancingPlan;
    },
    filterResponseData(res) {
      const ballonAmount = [];
      const withoutBallonAmount = [];

      res.forEach((item) => {
        if (item.ballonAmount === 0) {
          withoutBallonAmount.push(item);
        } else {
          ballonAmount.push(item);
        }
      });
      return { ballonAmount, withoutBallonAmount };
    },
    formattedPrice(num) {
      return `€ ${formatPrice(num)} ,-`;
    },
    closeTooltip(type) {
      if (type === "self_pay") {
        this.isSelfPayTooltipOpen = false;
      }
    },
    changeFinancingPlus(e) {
      const { checked } = e.target;
      this.financingPlus = checked;
      if (checked) this.paymentMethod = "financing_plus";
    },
  },
};
</script>

<style lang="scss" scoped>
.financed-plan-form {
  .check-list {
    li {
      margin-left: 0px;
      padding-left: 24px;
      &:before {
        font-size: 14px;
        color: #131313;
      }
    }
  }

  padding: 30px 0.625rem;

  @include breakpoint(desktop) {
    padding: 30px 0;
  }

  .btn {
    margin-left: auto;
  }

  .margin {
    margin-bottom: 30px;
  }

  &__checkbox {
    display: block;
    margin: 10px 0 25px;
    padding-top: 10px;
    border-top:1px solid $border-gray;
    > div {
      display: flex;
      align-items: center;
      .custom-checkbox {
        #financing-plus-checkbox + label {
          &:before {
            top: -2px;
          }
          &:after {
            top: -2px;
          }
        }
        + p {
          margin: 0px;
          margin-left: 20px;
        }
      }
    }
  }

  .financed-plan {
    @include breakpoint(desktop) {
      display: flex;
      > div {
        flex: 1;
        &:last-child {
          margin-left: 20px;
        }
      }
    }
  }

  .financed-plan-form__checkbox {
    display: none;
    &.mobile-only {
      display: block;
      margin-top: 30px;
    }
    @include breakpoint(desktop) {
      display: block;
      &.mobile-only {
        display: none;
      }
    }
  }

  .financed-plan__calculator {
    min-height: 226px;
    border-radius: 2px;
    background-color: $light-gray;
    margin-top: 20px;
    padding: 20px;
    > div {
      font-size: 14px;
      font-weight: 300;
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
    }
  }

  .financed-plan__range {
    > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }
  }
  .range-slider {
    width: 100%;
    padding: 0px;
  }
  &__sub-title {
    margin-bottom: 20px;
  }
  .radio-form-item {
    margin-bottom: 10px;
    h5 {
      font-size: 14px;
    }
    p {
      margin: 0 30px;
    }
    .financed-plan__range p {
      font-size: 14px;
      font-weight: 700;
      margin-right: 0px;
    }
  }
  .financed-plan-form__notes {
    position: relative;
    display: flex;
    flex-direction: column;
    margin-top: 10px;

    i {
      color: $blue;
    }

    button {
      position: absolute;
      right: 20px;
      top: 20px;
      display: none;
    }
    > div {
      font-size: 14px;
      color:$blue;
    }
    p {
      line-height: 18px;
      margin: 0;
    }
    .benefits-link {
      display: block;
      margin-top: 20px;
      padding: 10px;
      font-weight: 600;
      text-align: center;
      background-color: $darkgray;
      color: $white;
      border-radius: 50px;
    }
    h6 {
      font-size: 16px;
      margin-bottom: 10px;
      color: #131313;
    }
    // @include breakpoint(desktop) {
    //   position: absolute;
    //   top: 50%;
    //   right: -370px;
    //   transform: translateY(-50%);
    //   width: 370px;
    //   padding: 40px 70px 40px 50px;
    //   z-index: 1;
    //   margin-top: 0;
    //   border: none;
    //   box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3);
    //   background: $light-gray;

    //   > div {
    //     background: none;
    //     padding: 0;
    //   }

    //   .benefits-link {
    //     background-color: $white;
    //     color: $darkgray;
    //   }
    //   .tipp {
    //     color: $red;
    //   }
    //   .supersmall {
    //     font-size: 13px;
    //     line-height: 18px;
    //     color: $red;
    //   }
    //   &:after {
    //     content: "";
    //     position: absolute;
    //     width: 30px;
    //     height: 30px;
    //     left: -15px;
    //     top: 50%;
    //     transform: translateY(-50%) rotate(45deg);
    //     z-index: -1;
    //     background: $light-gray;
    //     box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3);
    //   }

    //   &:before {
    //     content: "";
    //     position: absolute;
    //     width: 31px;
    //     height: 70px;
    //     left: 0;
    //     top: 50%;
    //     transform: translateY(-50%);
    //     background: $light-gray;
    //   }
    //   button {
    //     display: block;
    //   }
    // }
  }
  .btn {
    margin-top: 10px;
  }
  &.with-error {
    .radio-form-item {
      border-color: $red;
    }
    .title {
      color: $red;
    }
    .error {
      font-size: 12px;
      line-height: 24px;
      color: $red;
    }
  }
  .financed-plan__deposit {
    margin-top: 20px;
    > div {
      padding: 15px 18px;
      border: 1px solid #dadada;
      margin-bottom: 10px;
      &.active, &:hover {
        border: 1px solid $black;
      }
    }
    h3 {
      font-size: 14px;
    }
    p {
      font-size: 14px;
      line-height: 18px;
    }
  }
  .financed-plan__deposit p {
    margin: 0;
  }

  .financed-plan__label {
    position: relative;
    font-size: 14px;
    font-weight: 700;
    display: block;
    h5 {
      font-size: 14px;
      margin-bottom: 5px;
    }
    input {
      margin-bottom: 20px;
      padding: 3px 12px;
      border-radius: 3px;
      border: 1px solid #dadada;
      background-color: #ffffff;
      width: 100%;
      line-height: 36px;
      -webkit-appearance: none;
      -moz-appearance: textfield;
      &[disabled] {
        background-color: #f4f4f4;
      }
      &::-webkit-inner-spin-button,
      &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
    &:after {
      position: absolute;
      content: "€";
      right: 15px;
      font-size: 14px;
      font-weight: 700;
      line-height: 36px;
      bottom: 23px;
    }
  }
  .financed-plan__price-container {
    margin: 20px 0 10px;
    p {
      font-size: 20px;
      font-weight: 700;
      line-height: 26px;
      text-align: right;
      margin-right: 0px;
    }
  }
  @include breakpoint(desktop) {
    .financed-plan__inputs {
      display: flex;
      > div {
        flex: 1;
        &:first-child {
          // margin-right: 40px;
        }
      }
    }
    .financed-plan__price-container {
      margin-top: 20px;
    }
  }
}
</style>

<style lang="scss">
.financed-plan-form {
  .range-slider-rail,
  .range-slider-fill {
    height: 10px;
    border-radius: 5px;
  }
  .range-slider-rail {
    background-color: #e5e5e5;
  }
  .range-slider-fill {
    background-color: $darkgray;
  }
  .range-slider-knob {
    width: 25px;
    height: 25px;
    border: 3px solid $darkgray;
  }
}
</style>
